import { IconButton } from '@mui/material';
import { iconName } from './iconNames';
import { IconUI } from './IconUI';
import { onClickHandler } from './utilities/click_handler';
import colors from './colors';

export type IconButtonProps = {
  name: iconName
  onClick: () => void
  disabled?: boolean
  color?: keyof typeof colors
};

export const IconButtonUI: React.FC<IconButtonProps> = ({ name, onClick, disabled, color }) => {
  return (
    <IconButton onClick={onClickHandler(onClick)} disabled={disabled}>
      <IconUI name={name} color={color} />
    </IconButton>
  );
};
